import { Collapse, Button } from '@indigo-ag/component-module';
import { CropCashFlowNote } from '@indigo-ag/schema';
import React, { useState } from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/pro-regular-svg-icons';
import i18next from 'i18next';
import { date } from 'shared/utils/date.util';

interface NotesProps {
  notes: CropCashFlowNote[];
}

const NotesCard = styled.div`
  margin: 16px 0;
  display: flex;
  justify-content: space-between;
`;
const Note = styled.p`
  margin: 0;
`;
const NoteDetails = styled.p`
  font-size: 13px;
  color: #303c41;
  margin-top: 8px;
`;
const NotesTitle = styled.p`
  font-size: 16px;
  color: #00577d;
  line-height: 24px;
  letter-spacing: 1.5%;
`;
export const CropCashFlowNotes: React.FunctionComponent<NotesProps> = ({ notes }) => {
  const [open, setOpen] = useState(false);

  return notes.length ? (
    <NotesCard>
      <Collapse in={open} collapsedHeight={'40px'}>
        <NotesTitle>{i18next.t('viewNotes')}</NotesTitle>
        {notes.map(note => {
          return (
            <div key={note.createdAt.toString()}>
              <Note>{note.note}</Note>
              <NoteDetails>
                {note.user}, {date.toPrettyDateTime(note.createdAt)}
              </NoteDetails>
            </div>
          );
        })}
      </Collapse>
      <Button onClick={() => setOpen(!open)} variant="tertiary">
        <FontAwesomeIcon icon={faChevronDown} flip={open ? 'vertical' : undefined}></FontAwesomeIcon>
      </Button>
    </NotesCard>
  ) : (
    <></>
  );
};
